// import React from "react";
// import CloudContent from "../Components/CloudContent";

// const Cloud = () => {
//   return <CloudContent />;
// };

// export default Cloud;
import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import CloudContent from "../Components/CloudContent";

const Cloud = () => {
  const seoData = getSEOData("/cloud");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <CloudContent />
    </>
  );
};

export default Cloud;
